import React from 'react';
import { styles } from '../AuthWrapper.styles';
import type { AuthFormState } from '../../hooks/useAuthForm';

const SignInForm: React.FC<{ form: AuthFormState }> = ({ form }) => {
  const { email, setEmail, password, setPassword, isSubmitting, handleSignIn, handleForgotPassword } = form;

  return (
    <form onSubmit={handleSignIn} style={styles.form}>
      <div style={styles.formGroup}>
        <label style={styles.label} htmlFor="email">Email</label>
        <input
          id="email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Enter your email"
          required
          style={styles.input}
          disabled={isSubmitting}
          autoComplete="off"
        />
      </div>
      <div style={styles.formGroup}>
        <label style={styles.label} htmlFor="password">Password</label>
        <input
          id="password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Enter your password"
          required
          style={styles.input}
          disabled={isSubmitting}
          autoComplete="new-password"
        />
        <button
          type="button"
          onClick={handleForgotPassword}
          style={styles.forgotPasswordLink}
          disabled={isSubmitting}
        >
          Forgot Password?
        </button>
      </div>
      <button
        type="submit"
        style={{
          ...styles.button,
          ...(isSubmitting ? styles.buttonDisabled : {}),
        }}
        disabled={isSubmitting}
      >
        {isSubmitting ? 'Signing in...' : 'Sign In'}
      </button>
    </form>
  );
};

export default SignInForm;
